import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { LANGUAGE_KEY } from "../Constants/mainKeys";
import Info from "../OrganizationAdminPages/Info/info";
import Overview from "../OrganizationAdminPages/Overview/overview";
import PaymentPackage from "../OrganizationAdminPages/PaymentPackage/paymentPackage";
import Paymentpackagehistory from "../OrganizationAdminPages/PaymentPackage/paymentPackageHistory";
import Messages from "../OrganizationPages/Messages/messages";
import NotFoundPage from "../Pages/404/notFoundPage";
import Notifications from "../Pages/Notifications/notifications";
import UnderMaintenancePage from "../Pages/UnderMaintenancePage/underMaintenancePage";
import ContactUs from "../UserPages/ContactUs/contactUs";
import FooterMenu from "../UserPages/FooterMenu/footerMenu";
import Finances from "./../Pages/Overview/finances";
import Profile from "./../Pages/Profile/profile";
import _Help from "../Pages/Help/_help";
import CustomPaymentPackage from "../UserPages/CustomPaymentPackage/customPaymentPackage";
import RolesService from "../Services/rolesService";
import { useSelector } from "react-redux";
import CoursesForOrgAdmin from "../OrganizationAdminPages/Courses/CoursesForOrgAdmin";
import Course from "../OrganizationAdminPages/Courses/CoursePriceForm";
import AuthenticationByRefreshToken from "../Pages/AuthenticationByRefreshToken/AuthenticationByRefreshToken";
import MainService from "../Services/mainService";
import GamificationDashboard from "../OrganizationPages/Gamification/Dashboard/GamificationDashboard";
import Resources from "../OrganizationPages/Gamification/Resources/Resources";
import Badges from "../OrganizationPages/Gamification/Badges/Badges";
import Leaderboards from "../OrganizationPages/Gamification/Leaderboards/Leaderboards";
import Badge from "../OrganizationPages/Gamification/Badges/Badge";
import ShopItems from "../OrganizationPages/Gamification/ShopItems/ShopItems";
import Leaderboard from "../OrganizationPages/Gamification/Leaderboards/Leaderboard";
import Quest from "../OrganizationPages/Gamification/Quests/Quest";
import Settings from "../OrganizationPages/Settings/Settings";
import EducationalUnits from "../OrganizationPages/Structure/EducationalUnit/EducationalUnits";
import EducationalUnitForm from "../OrganizationPages/Structure/EducationalUnit/EducationalUnitForm";
import CourseStudents from "../OrganizationAdminPages/Courses/CourseStudents";
import PaymentScheduleForOrgAdmin from "../OrganizationPages/PaymentSchedule/paymentScheduleForOrgAdmin";
import Divisions from "../OrganizationPages/Structure/Division/Divisions";
import DivisionForm from "../OrganizationPages/Structure/Division/DivisionForm";
import AdminWebinars from "../OrganizationAdminPages/Webinar/adminWebinars";
import UserTypes from "../DeveloperPages/userTypes";
import Permissions from "../DeveloperPages/permissions";

const DeveloperRoutes = () => {
	const { role } = useSelector(state => state.user);
	const [roleService, setRoleService] = useState(null);

	useEffect(() => {
		MainService.isJson(role) &&
			setRoleService(new RolesService(JSON.parse(role)));
	}, [role]);

	return roleService ? (
		<Switch>
			<Route
				path="/:language/organization-admin/payment-package"
				exact
				component={PaymentPackage}
			/>
			<Route
				path="/:language/developer/user-types"
				exact
				component={UserTypes}
			/>
			<Route
				path="/:language/developer/permissions"
				exact
				component={Permissions}
			/>
			<Route path="/:language/help" exact component={_Help} />
			<Route path="/:language/help/topic/:topicId" exact component={_Help} />
			<Route path="/:language/help/faq/:faqId" exact component={_Help} />
			{/* AuthenticationByRefreshToken */}
			<Route
				path="/:language/authentication/:refreshToken"
				exact
				component={AuthenticationByRefreshToken}
			/>
			{/* 404 */}
			<Route path="/:language/not-found/404" exact component={NotFoundPage} />
			{/* Server error page */}
			<Route
				path="/:language/under-maintenance"
				exact
				component={UnderMaintenancePage}
			/>
			<Redirect
				to={`/${localStorage.getItem(
					LANGUAGE_KEY,
				)}/organization-admin/payment-package`}
			/>
			{/* <Route component={NotFoundPage} /> */}
		</Switch>
	) : null;
};

export default DeveloperRoutes;
